import React from "react"
import styled from "styled-components"
import { FiChevronUp } from "react-icons/fi"
import media from "cssMix/index"

const StyledGoTop = styled.div`
  position: fixed;
  right: 0;
  bottom: 70px;
  z-index: 50;
  width: 50px;
  height: 50px;
  -webkit-tap-highlight-color: transparent;
  background-size: 100%;
  transform: translateZ(0);
  background: #f9be00;
  border-radius: 6px 0 0 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  > svg {
    height: 30px;
    width: 30px;
    color: #141620;
  }
  ${media.tablet`
    display:none;`}
`
const goToTop = (ref) => {
  ref.scroll({
    top: 0,
    left: 0,
    behavior: "smooth",
  })
}
const GoTopDesktop = ({ target }) => {
  return (
    <StyledGoTop
      key="gotop"
      onClick={() => goToTop(target)}
      className="gav2_btn_gotop"
    >
      <FiChevronUp />
    </StyledGoTop>
  )
}

export default GoTopDesktop
